import { useTheme } from '../../hooks/useTheme';

export function SwitchTheme() {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="form-check form-switch">
      <input
        className="form-check-input"
        type="checkbox"
        role="switch"
        id="flexSwitchCheckDefault"
        onChange={toggleTheme}
        checked={theme === 'dark'}
      />
      <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
        {theme === 'light' ? 'Claro' : 'Escuro'}
      </label>
    </div>
  );
}
